import { RecoverView as UIRecoverView, useHead } from '@mybonus/ui';

export function RecoverView() {
	useHead({ subtitle: 'Återställ ditt lösenord' });

	return <UIRecoverView />;
}
